import { Api, CompanyIntegration, Http } from '../../../models/index';
import { GetApi } from '../api/index';
import { CacheableResource } from '../CacheableResource';
import { GetResource } from '../GetResource';

export class GetAvailableIntegrations extends CacheableResource<
    CacheableResource.Params,
    CompanyIntegration[]
> {
    private getApi: GetApi;
    private getResource: GetResource<Api.Rel, CompanyIntegration[]>;

    constructor(http: Http) {
        super();
        this.getApi = new GetApi(http);
        this.getResource = new GetResource<Api.Rel, CompanyIntegration[]>(http);
    }

    protected doExecute(): Promise<CompanyIntegration[]> {
        return this.getApi.execute().then((api) => {
            return this.getResource
                .execute({
                    parent: api,
                    rel: 'available-company-integrations'
                })
                .then((companyIntegrations) => companyIntegrations!);
        });
    }
}
